import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/data/content";
import { TEST_IDS } from "@/constants/testIds";

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid={TEST_IDS.faq.root}
      className="py-24 md:py-40 border-t border-[#E5E1DA] bg-[#F3EFE9]"
    >
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="mb-14 md:mb-20 grid md:grid-cols-12 gap-6 items-end">
          <div className="md:col-span-3 eyebrow">Questions</div>
          <h2 className="md:col-span-9 font-serif-display font-black tracking-tight text-[clamp(38px,6vw,84px)] leading-[0.95]">
            The honest FAQ.
          </h2>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.8, ease: [0.2, 0.8, 0.2, 1] }}
        >
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                data-testid={TEST_IDS.faq.item(i + 1)}
                className="border-b border-[#E5E1DA] py-2"
              >
                <AccordionTrigger className="text-left py-6 hover:no-underline group">
                  <span className="flex items-center gap-6 pr-4">
                    <span className="font-mono-ui text-[11px] tracking-[0.24em] text-[#787672] uppercase w-8">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="font-serif-display text-xl md:text-2xl tracking-tight text-[#1C1C1A] group-hover:text-[#E07A5F] transition-colors duration-300">
                      {f.q}
                    </span>
                  </span>
                </AccordionTrigger>
                <AccordionContent className="pl-14 pr-6 pb-8 text-[16px] md:text-[17px] text-[#1C1C1A]/75 leading-relaxed max-w-[62ch]">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
